import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clapperboard } from "lucide-react";
import { api, fmtDuration, mediaSrc } from "@/lib/api";

const FILTERS = ["all", "rendering", "completed", "completed_with_errors"];

export default function HistoryPage() {
  const [items, setItems] = useState(null);
  const [filter, setFilter] = useState("all");
  useEffect(() => { api.get("/history").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  const visible = (items || []).filter((b) => filter === "all" || b.status === filter || (filter === "rendering" && b.status === "planning"));
  return (
    <div className="space-y-6 rise" data-testid="history-page">
      <div><span className="overline-label">History</span><h1 className="text-3xl sm:text-4xl font-bold tracking-tight mt-1">Past batches</h1></div>
      <div className="flex flex-wrap gap-2">{FILTERS.map((f) => <button key={f} onClick={() => setFilter(f)} className={`chip text-xs ${filter === f ? "chip-active" : "chip-idle"}`} data-testid={`history-filter-${f}`}>{f.replace(/_/g, " ")}</button>)}</div>
      {items === null && <div className="h-40 rounded-2xl shimmer" />}
      {items && visible.length === 0 && (
        <div className="card-surface p-12 text-center space-y-3" data-testid="history-empty">
          <Clapperboard className="mx-auto text-muted-foreground" />
          <p className="text-muted-foreground">No batches here yet.</p>
          <Link to="/editor" className="text-primary hover:underline text-sm">Start in the editor</Link>
        </div>
      )}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {visible.map((b) => (
          <Link key={b.id} to={`/editor/${b.project_id}?batch=${b.id}`} className="card-surface card-hover overflow-hidden block" data-testid={`history-item-${b.id}`}>
            <div className="aspect-video bg-black relative">
              {b.thumb_url && <img src={mediaSrc(b.thumb_url)} alt="" className="absolute inset-0 w-full h-full object-cover" />}
              <span className={`absolute top-2 left-2 rounded-full px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider ${b.status === "completed" ? "bg-primary text-primary-foreground" : b.status === "completed_with_errors" ? "bg-amber-500 text-black" : "bg-card text-foreground"}`}>{b.status.replace(/_/g, " ")}</span>
            </div>
            <div className="p-4 space-y-1">
              <p className="font-semibold truncate">{b.project_title}</p>
              <p className="text-xs font-mono text-muted-foreground">{new Date(b.created_at).toLocaleString()} · src {fmtDuration(b.source_duration)}</p>
              <p className="text-xs font-mono text-muted-foreground">{b.counts?.rendered || 0}/{b.count} rendered · {b.counts?.approved || 0} approved{b.counts?.failed ? ` · ${b.counts.failed} failed` : ""}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
